(() => {const init = root => {root.querySelectorAll('[data-pa-reading]').forEach(article => {if(article.dataset.paReady)return;article.dataset.paReady='true';const toc=article.querySelector('[data-pa-toc]');if(!toc)return;const list=toc.querySelector('ol');const headings=[...article.querySelectorAll('.pa-prose h2')].filter(h=>h.textContent.trim());if(headings.length<3)return;headings.forEach((heading,i)=>{if(!heading.id)heading.id='pa-reading-'+i;const li=document.createElement('li'),a=document.createElement('a');a.href='#'+heading.id;a.textContent=heading.textContent.trim();li.append(a);list.append(li);});toc.hidden=false;});};if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});}else init(document);document.addEventListener('shopify:section:load',event=>init(event.target));})();

// The quote app renders its navigation asynchronously with English defaults.
(() => {
  const start = () => {
    const config = document.getElementById('pa-quote-labels');
    if (!config) return;
    const labels = JSON.parse(config.textContent);
    const defaults = { Next: labels.next, Previous: labels.previous, Submit: labels.submit };
    let formObserver;
    const localize = form => {
      for (const button of form.querySelectorAll('[data-action-next], [data-action-previous]')) {
        for (const node of button.childNodes) {
          if (node.nodeType !== Node.TEXT_NODE) continue;
          const original = node.textContent.trim();
          if (defaults[original] && original !== defaults[original]) {
            node.textContent = node.textContent.replace(original, defaults[original]);
          }
        }
        if (button.getAttribute('data-next-text') === 'Next') {
          button.setAttribute('data-next-text', labels.next);
        }
        const submit = button.getAttribute('data-submit-text');
        if (submit?.includes('Submit') && labels.submit !== 'Submit') {
          button.setAttribute('data-submit-text', submit.replace('Submit', labels.submit));
        }
      }
    };
    const bind = () => {
      const form = document.querySelector('form[data-id="152408"]');
      if (!form) return;
      if (form === bind.form) return;
      formObserver?.disconnect();
      bind.form = form;
      localize(form);
      formObserver = new MutationObserver(() => localize(form));
      formObserver.observe(form, { childList: true, subtree: true, characterData: true });
    };
    const mountObserver = new MutationObserver(bind);
    mountObserver.observe(document.body, { childList: true, subtree: true });
    bind();
    window.addEventListener('pagehide', () => {
      mountObserver.disconnect();
      formObserver?.disconnect();
    }, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

document.addEventListener('DOMContentLoaded',()=>{const select=document.getElementById('QuoteProduct');if(!select)return;const interest=new URLSearchParams(window.location.search).get('interest');if(interest&&Array.from(select.options).some(option=>option.value===interest)){select.value=interest;}});
